import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledWrapper, StyledTile, StyledText } from './Tile.style';
import { TileBadge } from './TileBadge';
import { TileButtons } from './TileButtons';
import { useImage, useHover } from '../../hooks';
const variants = ['inline', 'full'];
const sizes = ['small', 'medium', 'full'];
const getStyle = (condition, style) => condition ? style : {};
export function Tile({ label, imageUrl, onClick, variant = 'inline', size = 'medium', badges = [], buttons = [], }) {
    var _a;
    const [hoverRef, isHovered] = useHover();
    const { size: imageSize, isLoaded: isImageLoaded } = useImage(imageUrl);
    const imageHeight = (((_a = hoverRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || NaN) *
        (imageSize.height / imageSize.width);
    return (_jsxs(StyledWrapper, { ref: hoverRef, variant: variant, size: size, onClick: onClick, style: getStyle(size === 'full' && !isNaN(imageHeight), {
            height: `${imageHeight}px`,
        }), title: label, children: [_jsx(StyledTile, { backgroundImage: imageUrl, size: size, style: getStyle(isImageLoaded, {
                    backgroundImage: `url(${imageUrl})`,
                }), children: _jsx(StyledText, { label: label, children: label }) }), badges.length > 0 && (_jsx(TileBadge, { visible: !isHovered || buttons.length === 0, badges: badges })), buttons.length > 0 && (_jsx(TileButtons, { visible: isHovered, buttons: buttons }))] }));
}
//# sourceMappingURL=Tile.js.map